import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-center-view',
    templateUrl: './center-view.component.html',
    styleUrls: ['./center-view.component.scss'],
    standalone: false
})
export class CenterViewComponent implements OnInit {
  @Input() title: string;
  @Input() isLoading: boolean;
  @Input() error: string;
  @Input() success: string;

  constructor() {}

  ngOnInit() {}
}
